import { render, staticRenderFns } from "./SchemaNew.vue?vue&type=template&id=9cd26e2a&scoped=true&"
import script from "./SchemaNew.vue?vue&type=script&lang=js&"
export * from "./SchemaNew.vue?vue&type=script&lang=js&"
import style0 from "./SchemaNew.vue?vue&type=style&index=0&id=9cd26e2a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd26e2a",
  null
  
)

export default component.exports